import React from "react";
import "./Invoice.css";
import html2pdf from "html2pdf.js"; // Import html2pdf library
import { FaDownload, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
// import { set } from "mongoose";

const InvoiceModal = ({ selectedOrder, onClose, user }) => {
  const createdAtDate = new Date(selectedOrder?.createdAt);
  if (!selectedOrder || !user) {
    return null;
  }
  console.log(selectedOrder);
  let GrandTotal=0;
  let GrandTaxable=0;
  let GrandIGST=0;

  const {
    orderNumber,
    orderItems,
    deliveryAddress,
    customerName,
    shippingAddress,
    billingAddress,
    orderDate,
    invoiceDate,
    pan,
    cin,
  } = selectedOrder;
  const userId = user?._id;
  const invoiceNo = `INV-${Date.now()}`;
  

  // Function to download invoice as PDF
  const downloadInvoice = () => {
    const invoiceContent = document.getElementById("invoice-modal");
    const options = {
      filename: `Invoice_${orderNumber}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().from(invoiceContent).set(options).save();
  };

  return (
    <div className="invoice-modal-overlay">
      <div className="invoice-modal" id="invoice-modal">
        <div className="btm">
          {" "}
          {/* Close Button */}
          <div className="close-button" onClick={onClose}>
            <FaTimes />
          </div>
          {/* Download Button */}
          <div className="download-button" onClick={downloadInvoice}>
            <FaDownload />
          </div>
        </div>

        {/* Invoice Header */}
        <header className="invoice-header">
          <h1>Tax Invoice</h1>
          <p>Invoice Number: {invoiceNo}</p>
        </header>

        {/* Invoice Address */}
        <section className="invoice-address">
          <div className="address-section">
            <h2>Bill From:</h2>
            <p>ANKUR PHARMA</p>
            <p>527-B,RAPTINAGAR PHASE-4</p>
            <p>CHARGAWAN</p>
            <p>Gorakhpur , Uttar Pradesh</p>
            <p>Phone: 9450472682</p>
            <p>DL.NO: UP5320B000825,UP5321B000819</p>
            <p>GSTIN: 09BILPR5887E1ZI</p>
          </div>

          <div className="address-section">
            <h2>Bill To:</h2>
            <p>{deliveryAddress?.fullName || user?.name}</p>
            {user?.role === 'employee' ? (
              <p>Employee ID: {user?._id?.slice(-6)}</p>
            ) : (
              <p>Customer</p>
            )}
            <p>{deliveryAddress?.addressLine1}</p>
            {deliveryAddress?.addressLine2 && <p>{deliveryAddress.addressLine2}</p>}
            <p>{deliveryAddress?.city} {deliveryAddress?.postalCode} {deliveryAddress?.state}</p>
            <p>Phone: {deliveryAddress?.phoneNumber || user?.MobileNumber}</p>
          </div>
        </section>

        {/* Invoice Details */}
        <section className="invoice-details">
          <p>
            <strong>Order ID:</strong> OD-{orderNumber}
          </p>
          <p>
            <strong>Order Date:</strong>{" "}
            {new Date(createdAtDate).toLocaleDateString()}
          </p>
          <p>
            <strong>Invoice Date:</strong> {new Date().toLocaleDateString()}
          </p>
          <p>
            <strong>PAN:</strong> {pan}
          </p>
          <p>
            <strong>CIN:</strong> {cin}
          </p>
        </section>

        {/* Invoice Table */}
        <section className="invoice-table">
          <table>
            <thead>
              <tr>
                <th>Product Title</th>
                <th>Qty</th>
                <th>Pack of</th>
                <th>Batch Number</th>
                <th>Gross Amount (₹)</th>
                <th>Discount (₹)</th>
                <th>Taxable Value (₹)</th>
                <th>Gst%</th>
                <th>IGST (₹)</th>
                <th>Total (₹)</th>
              </tr>
            </thead>
            <tbody>
              {orderItems.map((item) => {
                const {
                  gst,
                  mrp,
                  subtotal,
                  quantity,
                  productName,
                  packof,
                  batchNumber,
                } = item;

                const dealRate = (subtotal / quantity).toFixed(2);
                const discount = (mrp - dealRate) * quantity;
                const taxableValue = (mrp*quantity).toFixed(2)- parseFloat(discount);
                const igst = (taxableValue * (gst / 100)).toFixed(2);
                const total = parseFloat(taxableValue) + parseFloat(igst);
                  GrandTotal+=parseFloat(total)
                  // GrandTaxable+=taxableValue;
                  // GrandIGST+=igst;

                return (
                  <tr key={item._id}>
                    <td>{productName || "N/A"}</td>
                    <td>{quantity || "N/A"}</td>
                    <td>{packof || "N/A"}</td>
                    <td>{batchNumber || "N/A"}</td>
                    <td>{(mrp*quantity).toFixed(2) || "N/A"} / {mrp} each</td>
                    <td>{discount.toFixed(2) || "N/A"}</td>
                    <td>{taxableValue.toFixed(2) || "N/A"}</td>
                    <td>{gst || "N/A"}%</td>
                    <td>{igst || "N/A"}</td>
                    <td>{total.toFixed(2) || "N/A"}</td>
                    
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="6" className="total-label">
                  Grand Total (₹)
                </td>
                <td> </td>
                <td></td>
                <td></td>
                <td className="total-value"> ₹
                  {GrandTotal.toFixed(2) || "N/A"}
                </td>
              </tr>
            </tfoot>
          </table>
        </section>

        {/* Invoice Footer */}
        <footer className="invoice-footer">
          <p>This is a computer-generated invoice. No signature required.</p>
        </footer>
      </div>
    </div>
  );
};

export default InvoiceModal;